import { useLanguage } from 'hooks/i18n';
import { useTranslation } from 'react-i18next';
import FooterView from './presentational';

const Footer = () => {
  const [t] = useTranslation('global');
  const [language] = useLanguage();
  const f = (key) => t(`footerV2.${key}`);
  const to = (path) => `/${language}${path}`;

  // same columns as the original footer, pointing to the new pages
  const columns = [
    {
      title: f('platform'),
      links: [
        { label: f('howItWorks'), path: to('/platform') },
        { label: f('agents'), path: to('/agents') },
        { label: f('sources'), path: to('/sources') },
        { label: f('howWeWork'), path: to('/how-we-work') },
      ],
    },
    {
      title: f('solutions'),
      links: [
        { label: f('retention'), path: to('/solutions/retention') },
        { label: f('crossSell'), path: to('/solutions/cross-sell') },
        { label: f('recommendation'), path: to('/solutions/recommendation') },
        { label: f('efficiency'), path: to('/solutions/efficiency') },
        { label: f('decisions'), path: to('/solutions/decisions') },
        { label: f('byIndustry'), path: to('/industries/banking') },
      ],
    },
    {
      title: f('resources'),
      links: [
        { label: f('clients'), path: to('/cases') },
        { label: f('calculator'), path: to('/calculator') },
        { label: f('academy'), path: to('/academy') },
        { label: f('help'), path: to('/help') },
        { label: f('security'), path: to('/security') },
        { label: f('status'), path: to('/status') },
      ],
    },
    {
      title: f('company'),
      links: [
        { label: f('about'), path: to('/about') },
        { label: f('jobs'), path: to('/about#join') },
        { label: f('partners'), path: to('/about#partners') },
        { label: f('specialist'), path: to('/specialist') },
      ],
    },
  ];

  const legal = [
    { label: f('securityPolicy'), path: to('/legal/security') },
    { label: f('privacy'), path: to('/legal/privacy') },
    { label: f('terms'), path: to('/legal/terms') },
  ];

  const advertisingView = window.location.pathname.includes('free-demo-cx');

  return (
    <FooterView
      t={t}
      language={language}
      columns={columns}
      legal={legal}
      advertisingView={advertisingView}
    />
  );
};

export default Footer;
